/* DUNKPOINT cart drawer + floating checkout pill. */
(function () {
  'use strict';

  var root = document.querySelector('[data-dp-cart]');
  if (!root) return;

  var cfgEl = document.getElementById('dp-cart-config');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }
  var upsells = Array.isArray(CFG.upsells) ? CFG.upsells : [];

  var pill = document.querySelector('[data-dp-pill]');
  var els = {
    count: root.querySelector('[data-dp-count]'),
    items: root.querySelector('[data-dp-items]'),
    empty: root.querySelector('[data-dp-empty]'),
    emptyGrid: root.querySelector('[data-dp-empty-grid]'),
    reserve: root.querySelector('[data-dp-reserve]'),
    reserveTime: root.querySelector('[data-dp-reserve-time]'),
    upsell: root.querySelector('[data-dp-upsell]'),
    upsellList: root.querySelector('[data-dp-upsell-list]'),
    foot: root.querySelector('[data-dp-foot]'),
    sub: root.querySelector('[data-dp-sub]'),
    saveRow: root.querySelector('[data-dp-save-row]'),
    save: root.querySelector('[data-dp-save]'),
    total: root.querySelector('[data-dp-total]'),
    checkoutTotal: root.querySelector('[data-dp-checkout-total]'),
    barFill: root.querySelector('[data-dp-bar]'),
    shipText: root.querySelector('[data-dp-ship-text]')
  };

  var cart = null;
  var compareCache = {};
  var busy = false;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function number(cents, precision, thousands, decimal) {
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return head + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';
    var token = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(token);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = number(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = number(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = number(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = number(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = number(cents, 0, ' ', ''); break;
      default: value = number(cents, 2, ',', '.');
    }
    return fmt.replace(token, value);
  }
  window.dpMoney = money;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isSizeName(name) { return /size|tama|talla|taille|gr(o|ö)sse/i.test(name || ''); }

  function optionNames(data) {
    return (data.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  /* Size first, the same order as the product page. */
  function orderedIndexes(names) {
    var order = [];
    names.forEach(function (name, i) { if (isSizeName(name)) order.push(i); });
    names.forEach(function (name, i) { if (order.indexOf(i) < 0) order.push(i); });
    return order;
  }

  function openDrawer() {
    root.classList.add('is-open');
    root.removeAttribute('aria-hidden');
    document.body.classList.add('dp-cart-open');
    startReserve();
    syncPill();
    load();
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dp-cart-open');
    syncPill();
  }

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        fetchCompares();
        fetchRecommendations();
        return data;
      })
      .catch(function () {});
  }

  /* Cart AJAX does not return compare-at prices, so pull them per product once. */
  function fetchCompares() {
    if (!cart || !cart.items.length) return;
    var handles = [];
    cart.items.forEach(function (item) {
      if (item.handle && !(item.handle in compareCache) && handles.indexOf(item.handle) < 0) handles.push(item.handle);
    });
    if (!handles.length) { renderTotals(); return; }
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          if (p && p.variants) {
            p.variants.forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
          }
          compareCache[handle] = map;
        })
        .catch(function () { compareCache[handle] = {}; });
    })).then(function () {
      renderItems();
      renderTotals();
    });
  }

  /* "Upgrade your order" shows products related to what is already in the cart,
     from Shopify's own recommendations. The collection baked into the drawer
     config stays as the fallback for when there is nothing to recommend. */
  var recommended = null;

  function fetchRecommendations() {
    if (!cart || !cart.items.length) { recommended = null; return; }
    var productId = cart.items[0].product_id;
    if (recommended && recommended.forProduct === productId) return;
    fetch('/recommendations/products.json?product_id=' + productId + '&intent=related&limit=8',
      { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { recommended = null; return; }
        recommended = {
          forProduct: productId,
          list: products.map(function (p) {
            var seen = {};
            var variants = [];
            (p.variants || []).forEach(function (v) {
              var key = v.option1 == null ? v.title : v.option1;
              if (key == null || seen[key]) return;
              seen[key] = true;
              variants.push({ id: v.id, title: key, available: v.available });
            });
            return {
              id: p.id,
              title: p.title,
              url: p.url,
              image: p.featured_image || (p.images && p.images[0]) || null,
              price: p.price,
              compare: p.compare_at_price || 0,
              variants: variants
            };
          })
        };
        renderUpsell();
      })
      .catch(function () { recommended = null; });
  }

  function compareFor(item) {
    var map = compareCache[item.handle];
    var value = map ? map[item.variant_id] : 0;
    return value && value > item.final_price ? value : 0;
  }

  function render() {
    renderItems();
    renderUpsell();
    renderTotals();
    renderShipping();
    syncBubble();
    syncPill();
    /* Lets other scripts (the bundle strip and picker, assets/dp-bundle.js)
       follow the cart without fetching it again. */
    try { document.dispatchEvent(new CustomEvent('dp:cart:updated', { detail: { cart: cart } })); } catch (e) {}
  }

  function itemOptions(item) {
    var bits = [];
    var opts = (item.options_with_values || []).filter(function (o) {
      return o.value && o.value !== 'Default Title';
    });
    opts.sort(function (a, b) { return (isSizeName(b.name) ? 1 : 0) - (isSizeName(a.name) ? 1 : 0); });
    opts.forEach(function (o) { bits.push(esc(o.name) + ': ' + esc(o.value)); });

    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var value = item.properties[k];
        if (k.charAt(0) === '_' || !value) return;
        /* The options app appends its fee to the value, e.g. "(Name + Number) | 4.99". */
        value = String(value).split('|')[0].trim();
        if (value) bits.push(esc(k) + ': ' + esc(value));
      });
    }
    return bits;
  }

  function renderItems() {
    if (!cart) return;
    var empty = cart.item_count === 0;
    root.classList.toggle('is-empty', empty);
    els.empty.hidden = !empty;
    els.foot.hidden = empty;
    if (els.reserve) els.reserve.hidden = empty;
    els.count.textContent = '(' + cart.item_count + ')';
    if (empty) renderEmpty();

    els.items.innerHTML = cart.items.map(function (item) {
      var compare = compareFor(item);
      var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">' : '';
      var opts = itemOptions(item);
      return '<div class="dp-cd__item" data-key="' + esc(item.key) + '">' +
        '<a class="dp-cd__thumb" href="' + esc(item.url) + '">' + img + '</a>' +
        '<div class="dp-cd__meta">' +
        '<div class="dp-cd__row1">' +
        '<a class="dp-cd__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        '<button type="button" class="dp-cd__rm" data-dp-remove aria-label="' + esc(CFG.removeLabel || 'Remove') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>' +
        '</button>' +
        '</div>' +
        (opts.length ? '<p class="dp-cd__opt">' + opts.join(' &middot; ') + '</p>' : '') +
        '<div class="dp-cd__row2">' +
        '<span class="dp-cd__qty">' +
        '<button type="button" data-dp-qty="-1" aria-label="' + esc(CFG.decreaseLabel || 'Decrease') + '">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-dp-qty="1" aria-label="' + esc(CFG.increaseLabel || 'Increase') + '">+</button>' +
        '</span>' +
        '<span class="dp-cd__prices">' +
        (compare ? '<s>' + money(compare * item.quantity) + '</s>' : '') +
        '<b>' + money(item.final_line_price) + '</b>' +
        '</span>' +
        '</div>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  /* ---------- empty cart: offer + a best sellers grid ---------- */
  var emptyBuilt = false;
  var emptyData = {};

  function renderEmpty() {
    if (!els.emptyGrid || emptyBuilt) return;
    var list = Array.isArray(CFG.emptyProducts) ? CFG.emptyProducts : [];
    if (!list.length) return;
    emptyBuilt = true;

    els.emptyGrid.innerHTML = list.map(function (p) {
      var off = p.compare > p.price ? Math.round(((p.compare - p.price) * 100) / p.compare) : 0;
      return '<div class="dp-ec__card" data-ec-handle="' + esc(p.handle) + '">' +
        (off ? '<span class="dp-ec__off">-' + off + '%</span>' : '') +
        '<a class="dp-ec__img" href="' + esc(p.url) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '</a>' +
        '<div class="dp-ec__body">' +
        '<a class="dp-ec__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="dp-ec__prices"><b>' + money(p.price) + '</b>' +
        (off ? '<s>' + money(p.compare) + '</s>' : '') + '</span>' +
        '<div class="dp-ec__opts" data-ec-opts></div>' +
        '<button type="button" class="dp-ec__add" data-ec-add disabled>' + esc(CFG.addLabel || '+ Add') + '</button>' +
        '</div></div>';
    }).join('');

    list.forEach(function (p) { hydrateEmptyCard(p.handle); });
  }

  function hydrateEmptyCard(handle) {
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        emptyData[handle] = data;
        var card = els.emptyGrid.querySelector('[data-ec-handle="' + handle + '"]');
        if (!card) return;
        var names = optionNames(data);
        var order = orderedIndexes(names).slice(0, 2);

        card.querySelector('[data-ec-opts]').innerHTML = order.map(function (index) {
          var values = [];
          data.variants.forEach(function (v) {
            var value = v['option' + (index + 1)];
            if (value && values.indexOf(value) < 0) values.push(value);
          });
          if (values.length < 2) return '';
          return '<select class="dp-ec__sel" data-ec-opt="' + index + '" aria-label="' + esc(names[index]) + '">' +
            values.map(function (value) {
              return '<option value="' + esc(value) + '">' + esc(value) + '</option>';
            }).join('') + '</select>';
        }).join('');
        card.querySelector('[data-ec-add]').disabled = false;
      })
      .catch(function () {});
  }

  function addFromEmptyCard(card, button) {
    var data = emptyData[card.getAttribute('data-ec-handle')];
    if (!data) return;
    var picks = [].slice.call(card.querySelectorAll('[data-ec-opt]'));
    var variant = data.variants.filter(function (v) {
      return v.available && picks.every(function (select) {
        return v['option' + (Number(select.getAttribute('data-ec-opt')) + 1)] === select.value;
      });
    })[0];
    if (!variant) return;
    addVariant(variant.id, 1, button);
  }

  function renderUpsell() {
    if (!els.upsell) return;
    var inCart = {};
    if (cart) cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var source = (recommended && recommended.list.length) ? recommended.list : upsells;
    var list = source.filter(function (p) { return !inCart[p.id] && p.variants.length; }).slice(0, 4);

    if (!list.length || !cart || !cart.item_count) { els.upsell.hidden = true; return; }
    els.upsell.hidden = false;
    els.upsellList.innerHTML = list.map(function (p, i) {
      var opts = p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>';
      }).join('');
      return '<div class="dp-cd__up">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<img alt="">') +
        '<div class="dp-cd__upinfo">' +
        '<a class="dp-cd__upname" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="dp-cd__upprice">' +
        (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') +
        '<b>' + money(p.price) + '</b>' +
        '</span>' +
        '</div>' +
        (p.variants.length > 1
          ? '<select class="dp-cd__upsel" data-dp-up-variant="' + i + '" aria-label="' + esc(CFG.sizeLabel || 'Size') + '">' + opts + '</select>'
          : '<input type="hidden" data-dp-up-variant="' + i + '" value="' + p.variants[0].id + '">') +
        '<button type="button" class="dp-cd__upadd" data-dp-up-add="' + i + '">' + esc(CFG.addLabel || '+ Add') + '</button>' +
        '</div>';
    }).join('');
  }

  function renderTotals() {
    if (!cart) return;
    var gross = 0;
    var known = true;
    cart.items.forEach(function (item) {
      var compare = compareFor(item);
      if (!compare && !(item.handle in compareCache)) known = false;
      gross += (compare || item.final_price) * item.quantity;
    });
    var save = gross - cart.total_price;

    els.sub.innerHTML = money(known && save > 0 ? gross : cart.items_subtotal_price);
    if (known && save > 0) {
      els.saveRow.hidden = false;
      els.save.innerHTML = '&minus; ' + money(save);
    } else {
      els.saveRow.hidden = true;
    }
    els.total.innerHTML = money(cart.total_price);
    if (els.checkoutTotal) els.checkoutTotal.innerHTML = money(cart.total_price);
  }

  function renderShipping() {
    if (!els.barFill || !cart) return;
    var threshold = CFG.freeShipping || 0;
    if (!threshold || cart.total_price >= threshold) {
      els.barFill.style.width = '100%';
      els.shipText.classList.remove('is-away');
      els.shipText.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' + esc(CFG.freeShippingOn || 'Shipping is FREE!');
    } else {
      els.barFill.style.width = Math.max(4, Math.round((cart.total_price / threshold) * 100)) + '%';
      els.shipText.classList.add('is-away');
      els.shipText.textContent = (CFG.freeShippingOff || 'You are [amount] away from free shipping').replace('[amount]', money(threshold - cart.total_price));
    }
  }

  /* The header count is rendered by Liquid, so it goes stale after an AJAX
     change, and it is missing entirely when the page loaded with an empty
     cart. Keep it in step and hide it again when the cart is emptied. */
  function syncBubble() {
    if (!cart) return;
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var badge = link.querySelector('.dp-cart__count');
    if (!badge) {
      if (!cart.item_count) return;
      badge = document.createElement('span');
      badge.className = 'dp-cart__count';
      (link.querySelector('.dp-cart__icon') || link).appendChild(badge);
    }
    badge.textContent = cart.item_count;
    badge.hidden = cart.item_count === 0;
  }

  function syncPill() {
    if (!pill) return;
    var on = cart && cart.item_count > 0 && !root.classList.contains('is-open');
    pill.classList.toggle('is-on', !!on);
    if (!on) return;
    pill.querySelector('[data-dp-pill-n]').textContent = cart.item_count;
    pill.querySelector('[data-dp-pill-total]').innerHTML = money(cart.total_price);

    var threshold = CFG.freeShipping || 0;
    var ratio = !threshold ? 1 : Math.min(1, cart.total_price / threshold);
    var ring = pill.querySelector('[data-dp-pill-ring]');
    var circumference = 2 * Math.PI * 22.5;
    ring.setAttribute('stroke-dasharray', circumference * ratio + ' ' + circumference);
    ring.setAttribute('stroke', ratio >= 1 ? '#22c55e' : '#ffd014');
    pill.querySelector('[data-dp-pill-sub]').textContent = ratio >= 1 ? (CFG.pillUnlocked || 'Checkout') : (CFG.pillLocked || 'Checkout');
  }

  var reserveTimer = null;
  function startReserve() {
    if (!els.reserveTime || reserveTimer) return;
    var minutes = CFG.reserveMinutes || 0;
    if (!minutes) return;
    var key = 'dp-cart-reserve';
    var until = 0;
    try { until = Number(sessionStorage.getItem(key) || 0); } catch (e) {}
    if (!until || until < Date.now() || until > Date.now() + minutes * 60000) {
      until = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(key, String(until)); } catch (e) {}
    }
    function tick() {
      var left = Math.max(0, Math.round((until - Date.now()) / 1000));
      els.reserveTime.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      if (left <= 0) {
        clearInterval(reserveTimer);
        reserveTimer = null;
        if (els.reserve) els.reserve.hidden = true;
      }
    }
    tick();
    reserveTimer = setInterval(tick, 1000);
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { cart = data; render(); fetchCompares(); fetchRecommendations(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function addVariant(id, quantity, button) {
    if (busy) return;
    busy = true;
    if (button) button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    })
      .then(function () { return load(); })
      .catch(function () {})
      .then(function () { busy = false; if (button) button.disabled = false; });
  }

  function addFromForm(form, button) {
    if (busy) return;
    busy = true;
    if (button) button.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        busy = false;
        if (button) button.removeAttribute('aria-busy');
        if (data && data.status && data.status !== 200) return;
        openDrawer();
      })
      .catch(function () {
        busy = false;
        if (button) button.removeAttribute('aria-busy');
      });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-dp-close]')) { closeDrawer(); return; }
    var qty = e.target.closest('[data-dp-qty]');
    if (qty) {
      var line = qty.closest('[data-key]');
      var current = Number(line.querySelector('.dp-cd__qty span').textContent) || 1;
      changeLine(line.getAttribute('data-key'), Math.max(0, current + Number(qty.getAttribute('data-dp-qty'))));
      return;
    }
    var remove = e.target.closest('[data-dp-remove]');
    if (remove) { changeLine(remove.closest('[data-key]').getAttribute('data-key'), 0); return; }
    var ecAdd = e.target.closest('[data-ec-add]');
    if (ecAdd) { addFromEmptyCard(ecAdd.closest('[data-ec-handle]'), ecAdd); return; }
    var add = e.target.closest('[data-dp-up-add]');
    if (add) {
      var index = add.getAttribute('data-dp-up-add');
      var picker = els.upsellList.querySelector('[data-dp-up-variant="' + index + '"]');
      if (picker && picker.value) addVariant(picker.value, 1, add);
      return;
    }
    var promoToggle = e.target.closest('[data-dp-promo-toggle]');
    if (promoToggle) { promoToggle.closest('[data-dp-promo]').classList.toggle('is-open'); return; }
    var promoApply = e.target.closest('[data-dp-promo-apply]');
    if (promoApply) {
      var code = root.querySelector('[data-dp-promo-input]').value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      return;
    }
    if (e.target.closest('[data-dp-checkout]')) window.location.href = '/checkout';
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#cart-icon-bubble, [data-dp-cart-open], a[href$="/cart"], a[href$="/cart/"]');
    if (!trigger || trigger.closest('[data-dp-cart]')) return;
    e.preventDefault();
    openDrawer();
  }, true);

  if (pill) pill.addEventListener('click', function () { openDrawer(); });

  /* The product options app takes over the add-to-cart click and sends the
     shopper to /cart. Claim the click first and turn it into a form submit,
     which the handler below picks up. */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('button[name="add"], button[type="submit"]');
    if (!button || button.disabled) return;
    var form = button.form || button.closest('form');
    if (!form || String(form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    e.preventDefault();
    e.stopPropagation();
    addFromForm(form, form.querySelector('[name="add"], [type="submit"]'));
  }, true);

  load();
})();
